import React from "react";
import "./AdminPageHero.css";

/** Shared reference-led page introduction. Values are supplied by each live workflow. */
export default function AdminPageHero({ title, description, metrics = [], children }) {
  return <header className="bbw-page-hero">
    <div className="bbw-page-hero-copy"><p className="bbw-page-eyebrow">Beyond Board / Business workspace</p><h1>{title}</h1><p className="bbw-page-description">{description}</p></div>
    {(metrics.length > 0 || children) && <div className="bbw-page-hero-bottom"><dl className="bbw-page-metrics">{metrics.map(({ label, value, tone }) => <div key={label}><dt>{label}</dt><dd className={tone ? `is-${tone}` : undefined}>{value}</dd></div>)}</dl>{children && <div className="bbw-page-hero-actions">{children}</div>}</div>}
  </header>;
}
